export const ADMIN_POSITION = {
  BRANCH_HEAD: "BRANCH_HEAD",
  STAFF: "STAFF",
};

export const ACCOUNT_TYPE = {
  BANK: "BANK",
  CRYPTO: "CRYPTO",
};
